import { render, staticRenderFns } from "./barCharts.vue?vue&type=template&id=c1a06a44"
import script from "./barCharts.vue?vue&type=script&lang=js"
export * from "./barCharts.vue?vue&type=script&lang=js"
import style0 from "./barCharts.vue?vue&type=style&index=0&id=c1a06a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports